import { Boogaloo, Yellowtail, Noto_Sans } from 'next/font/google';

const boogaloo = Boogaloo({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-boogaloo',
  weight: ['400'],
});

const yellowtail = Yellowtail({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-yellowtail',
  weight: ['400'],
});

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

export const supportedFonts = [boogaloo, yellowtail, notoSans];
